export const MAXPAYOUT_DATA = "MAXPAYOUT_DATA";
export const MAXPAYOUT_HIDE_ERROR = "MAXPAYOUT_HIDE_ERROR";
export const MAXPAYOUT_ERROR = "MAXPAYOUT_ERROR";
